import type { ToastMessageOptions } from 'primevue/toast';

export const DEFAULT_ERROR_MESSAGE = 'Ошибка!';
export const SERVER_ERROR_MESSAGE = 'Ошибка соединения с сервером';

export const parseError = (error: any = DEFAULT_ERROR_MESSAGE) => {
  const messages: string[] = [];

  if (typeof error === 'string') {
    messages.push(error);
    return messages;
  }

  const contentType = error.response?.headers?.['content-type'] ?? '';
  const isJson = contentType.includes('application/json');
  const data = error.response?.data;

  // No response (connection lost) or non-JSON body (e.g. Django HTML 500 page).
  // Never render the raw HTML/string — show a default server error instead.
  if (!error.response || !isJson || typeof data !== 'object' || data === null) {
    messages.push(SERVER_ERROR_MESSAGE);
    return messages;
  }

  if (data.detail) {
    messages.push(data.detail);
  } else {
    Object.keys(data).forEach((key) => {
      const field = data[key];
      const fields = Array.isArray(field) ? field : [field];
      messages.push(...fields);
    });
  }

  return messages;
};

let toastInstance: {
  add: (
    options: ToastMessageOptions & { summary: string; life?: number },
  ) => void;
} | null = null;

export const setToastInstance = (instance: typeof toastInstance) => {
  toastInstance = instance;
};

export const showToast = (
  message: string,
  severity: ToastMessageOptions['severity'] = 'error',
) => {
  if (toastInstance) {
    toastInstance.add({
      summary: message.replace(/\.$/, ''),
      severity,
      life: 6000,
    });
  }
};

export const displayError = (messages: string[]) => {
  messages.forEach((message) => showToast(message));
};
